import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { normalizeZip, normalizeCCDate } from '../../Helpers/normalizers';
import {
  samePayee,
  personCompany,
  zipCode,
  creditCardNumber,
  creditCardDate,
} from '../../Helpers/validators';
import PayeeSameField from './PayeeSameField';
import CardExpField from './CardExpField';
import RenterField from './RenterField';
import StateField from './StateField';
import CountryField from './CountryField';
import { usStatePropType } from '../Insured/StateField';
import {
  TextInput,
  CardNumberInput,
  CardCVVInput,
  Button,
} from '@jauntin/react-ui';
import { validators, normalizers } from '@jauntin/utilities';
const { required, creditCardCvv } = validators;
const { normalizeCreditCard, normalizeCVV } = normalizers;

const Edit = ({
  enabled,
  confirm,
  show,
  valid,
  isLoading,
  payeeSame,
  errorMessage,
  payeeRenter,
  usStates,
}) =>
  show && (
    <>
      <div className="mb-1">
        We accept Visa, Mastercard, American Express or Discover.
      </div>
      <Field
        component={CardNumberInput}
        validate={[required, creditCardNumber]}
        normalize={normalizeCreditCard}
        name="payeeCardNum"
        errorClassName="d-inline ml-2"
        inputClassName="form-control-lg"
        disabled={!enabled}
      />
      <div className="form-group form-row">
        <Field
          component={TextInput}
          validate={[required]}
          name="payeeCardName"
          label="Name on Card"
          ariaLabel="Credit Card Name"
          wrapperClassName="col-md mb-3 d-flex flex-column"
          errorClassName="form-group--order-4 mt-2"
          inputClassName="form-control-lg"
          disabled={!enabled}
        />
        <Field
          component={CardExpField}
          validate={[required, creditCardDate]}
          normalize={normalizeCCDate}
          name="payeeCardExp"
          type="text"
          disabled={!enabled}
        />
        <Field
          component={CardCVVInput}
          validate={[required, creditCardCvv]}
          normalize={normalizeCVV}
          name="payeeCardCVV"
          label="CVV"
          placeholder="XXX"
          wrapperClassName="col-auto d-flex flex-column"
          errorClassName="form-group--order-4 mt-2"
          inputClassName="form-control-lg mw--130"
          disabled={!enabled}
        />
      </div>
      <div className="form-group">
        <PayeeSameField
          name="payeeSame"
          validate={[required, samePayee]}
          disabled={!enabled}
        />
      </div>
      {!payeeSame && (
        <div id="newPayeeInfo">
          <RenterField name="payeeRenter" validate={[personCompany]} />
          {!payeeRenter && (
            <div id="payeeIndividual" className="form-row">
              <Field
                component={TextInput}
                validate={[required]}
                name="payeeFirstName"
                label="First name"
                ariaLabel="First name"
                placeholder="First name"
                wrapperClassName="col-sm"
                inputClassName="form-control-lg"
              />
              <Field
                component={TextInput}
                validate={[required]}
                name="payeeLastName"
                label="Last name"
                ariaLabel="Last name"
                placeholder="Last name"
                wrapperClassName="col-sm"
                inputClassName="form-control-lg"
              />
            </div>
          )}
          {payeeRenter && (
            <div id="payeeCompany" className="form-row">
              <Field
                component={TextInput}
                validate={[required]}
                name="payeeCompany"
                label="Company name"
                ariaLabel="Company name"
                placeholder="Company name"
                errorClassName="d-inline ml-2"
                wrapperClassName="col-sm"
                inputClassName="form-control-lg"
              />
            </div>
          )}
          <div className="form-group">
            <Field
              component={TextInput}
              validate={[required]}
              name="payeeAddress"
              label="Street Address"
              ariaLabel="Address"
              placeholder="Address"
              subtext="Mailing address, including apartment, suite, unit, building, floor, etc.."
              inputClassName="form-control-lg"
            />
          </div>
          <div className="form-row">
            <Field
              component={TextInput}
              validate={[required]}
              name="payeeCity"
              label="City"
              ariaLabel="City"
              placeholder="City"
              wrapperClassName="col-sm"
              inputClassName="form-control-lg"
            />
            <Field
              component={StateField}
              validate={[required]}
              name="payeeState"
              type="select"
              usStates={usStates}
            />
            <Field
              component={TextInput}
              validate={[required, zipCode]}
              normalize={normalizeZip}
              name="payeeZip"
              label="Zipcode"
              ariaLabel="Zipcode"
              placeholder="Zipcode"
              pattern="\d*"
              inputMode="numeric"
              wrapperClassName="col-sm"
              inputClassName="form-control-lg"
            />
          </div>
          <div className="form-row" hidden>
            <Field
              component={CountryField}
              validate={[required]}
              name="payeeCountry"
              type="select"
              input={{ disabled: true }}
            />
          </div>
        </div>
      )}
      <hr />

      <div className="float-right">
        {errorMessage && <div className="form-error">{errorMessage}</div>}
        <Button
          disabled={!valid || isLoading}
          onClick={confirm}
          text="Confirm Payment Information"
          className="btn-primary"
        />
      </div>
    </>
  );
Edit.propTypes = {
  enabled: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  payeeSame: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  payeeRenter: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
};

export default Edit;
